export enum HttpCustomParams {
  HIDE_SPINNER = 'hide_spinner',
  BYPASS_ERROR_HANDLER = 'bypassErrorHandler',
}
